import type { NewsTimelineItem } from "@/types/news";

interface ArticleTimelineProps {
  items: NewsTimelineItem[];
}

function ArticleTimeline({ items }: ArticleTimelineProps) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="px-5 py-4 border-b border-background-200 bg-background-100">
        <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-5 h-5 flex items-center justify-center text-primary-600">
            <i className="ri-history-line" />
          </span>
          事件时间线
        </h3>
      </div>
      <ol className="relative px-5 py-5">
        <span className="absolute left-[30px] top-7 bottom-7 w-px bg-background-300" aria-hidden="true" />
        {items.map((item, idx) => (
          <li key={`${item.time}-${idx}`} className="relative flex gap-4 pb-5 last:pb-0">
            <span
              className={`relative z-10 shrink-0 w-[22px] h-[22px] mt-0.5 flex items-center justify-center rounded-full text-[10px] font-bold ${
                idx === items.length - 1
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200 text-foreground-700"
              }`}
            >
              {idx + 1}
            </span>
            <div className="flex-1 min-w-0">
              <span className="block text-xs font-medium text-primary-600 mb-1">{item.time}</span>
              <p className="text-sm leading-relaxed text-foreground-700">{item.text}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default ArticleTimeline;